import React from "react";
import PageTitle from "../components/pagetitle/PageTitle";
import Footer from "../components/footer/Footer";
import Sidebar from "../components/sidebar/Sidebar";
import { Link } from "react-router-dom";

import img1 from "../assets/images/layouts/blog-detail.png";
import avt1 from "../assets/images/layouts/avt-01.png";
import avt2 from "../assets/images/layouts/avt-02.png";
import avt3 from "../assets/images/layouts/avt-03.png";
import avt4 from "../assets/images/layouts/avt-04.png";

function TermsOfUse(props) {
  return (
    <div className="wrapper">
      <PageTitle title="Terms Of Use" />

      <section className="bloglist">
        <div className="container">
          <div className="row">
            <div className="bloglist__main">
              <div className="list details">
                {/* <h4 className="title">Terms of Use</h4> */}
                

                {/* <div className="line"></div> */}

                <div className="content-d">
                  <ul className="list-social">
                    <li>
                      <Link to="#">
                        <svg
                          width="9"
                          height="16"
                          viewBox="0 0 9 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.57969 9.03953C2.51969 9.03953 1.19969 9.03953 0.599688 9.03953C0.279688 9.03953 0.179688 8.91953 0.179688 8.61953C0.179688 7.81953 0.179688 6.99953 0.179688 6.19953C0.179688 5.87953 0.299688 5.77953 0.599688 5.77953H2.57969C2.57969 5.71953 2.57969 4.55953 2.57969 4.01953C2.57969 3.21953 2.71969 2.45953 3.11969 1.75953C3.53969 1.03953 4.13969 0.559531 4.89969 0.279531C5.39969 0.0995311 5.89969 0.0195312 6.43969 0.0195312H8.39969C8.67969 0.0195312 8.79969 0.139531 8.79969 0.419531V2.69953C8.79969 2.97953 8.67969 3.09953 8.39969 3.09953C7.85969 3.09953 7.31969 3.09953 6.77969 3.11953C6.23969 3.11953 5.95969 3.37953 5.95969 3.93953C5.93969 4.53953 5.95969 5.11953 5.95969 5.73953H8.27969C8.59969 5.73953 8.71969 5.85953 8.71969 6.17953V8.59953C8.71969 8.91953 8.61969 9.01953 8.27969 9.01953C7.55969 9.01953 6.01969 9.01953 5.95969 9.01953V15.5395C5.95969 15.8795 5.85969 15.9995 5.49969 15.9995C4.65969 15.9995 3.83969 15.9995 2.99969 15.9995C2.69969 15.9995 2.57969 15.8795 2.57969 15.5795C2.57969 13.4795 2.57969 9.09953 2.57969 9.03953Z"
                            fill="white"
                          ></path>
                        </svg>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <svg
                          width="15"
                          height="12"
                          viewBox="0 0 15 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.5 1.42062C13.9794 1.66154 13.4246 1.82123 12.8462 1.89877C13.4412 1.524 13.8954 0.935077 14.1089 0.225231C13.5541 0.574154 12.9416 0.820615 12.2889 0.958154C11.7621 0.366462 11.0114 0 10.1924 0C8.60337 0 7.32412 1.36062 7.32412 3.02862C7.32412 3.26862 7.34338 3.49938 7.39062 3.71908C5.0045 3.59631 2.89313 2.38985 1.47475 0.552C1.22712 1.00523 1.08188 1.524 1.08188 2.08246C1.08188 3.13108 1.59375 4.06062 2.35675 4.59877C1.89562 4.58954 1.44325 4.44831 1.06 4.22585C1.06 4.23508 1.06 4.24708 1.06 4.25908C1.06 5.73046 2.05487 6.95262 3.3595 7.23415C3.12587 7.30154 2.87125 7.33385 2.607 7.33385C2.42325 7.33385 2.23775 7.32277 2.06362 7.28215C2.4355 8.48123 3.49075 9.36277 4.7455 9.39138C3.769 10.1972 2.52912 10.6828 1.18688 10.6828C0.9515 10.6828 0.72575 10.6717 0.5 10.6412C1.77137 11.5062 3.27813 12 4.903 12C10.1845 12 13.072 7.38462 13.072 3.384C13.072 3.25015 13.0676 3.12092 13.0615 2.99262C13.6311 2.56615 14.1097 2.03354 14.5 1.42062Z"
                            fill="white"
                          ></path>
                        </svg>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0006 14V8.87249C14.0006 6.35249 13.4581 4.42749 10.5181 4.42749C9.10062 4.42749 8.15563 5.19749 7.77063 5.93249H7.73563V4.65499H4.95312V14H7.85813V9.36249C7.85813 8.13749 8.08563 6.96499 9.59063 6.96499C11.0781 6.96499 11.0956 8.34749 11.0956 9.43249V13.9825H14.0006V14Z"
                            fill="white"
                          ></path>
                          <path
                            d="M0.226562 4.65479H3.13156V13.9998H0.226562V4.65479Z"
                            fill="white"
                          ></path>
                          <path
                            d="M1.68 0C0.7525 0 0 0.7525 0 1.68C0 2.6075 0.7525 3.3775 1.68 3.3775C2.6075 3.3775 3.36 2.6075 3.36 1.68C3.36 0.7525 2.6075 0 1.68 0Z"
                            fill="white"
                          ></path>
                        </svg>
                      </Link>
                    </li>
                  </ul>

                  <div className="main">
                    {/* noi dung */}
                    <p>
                      These Terms of Use ("Terms") govern your ("User", "you",
                      "your") access to and use of the services provided by
                      GMGN, including but not limited to web and mobile
                      applications, bots, channels, and groups ("Services").
                    </p>
                    <h5>1. ACCEPTANCE OF AGREEMENT</h5>
                    <p>
                      THESE TERMS ESTABLISH THE LEGALLY BINDING CONDITIONS FOR
                      YOUR USE OF THE SERVICES, INCLUDING ALL RELATED TOOLS, WEB
                      AND MOBILE APPLICATIONS, SMART CONTRACTS, AND APIS
                      ("PLATFORM"). BY ACCESSING OR USING THE PLATFORM, YOU
                      AGREE TO BE BOUND BY THESE TERMS AND OUR PRIVACY POLICY.
                      YOU MUST BE AT LEAST 18 YEARS OLD TO USE THE SERVICES. IF
                      YOU DO NOT AGREE, DO NOT USE THE PLATFORM.
                    </p>
                    <p>
                      Notice: These Terms include an arbitration clause for
                      dispute resolution, which affects your legal rights.
                    </p>
                    <p>
                      By accessing, submitting information to, or using the
                      Services, or by signing in using a Wallet, you agree to
                      comply with all applicable laws, including tax and tariff
                      regulations. In accordance with GDPR, users in the EU
                      consent to the processing of personal data as necessary
                      for these Terms and the Services. If you disagree with
                      these Terms, please discontinue using the Services. This
                      Agreement is referred to herein as the "Agreement."
                    </p>
                    <h5>2. AMENDMENTS</h5>
                    <p>
                      GMGN may revise this Agreement and its Privacy Policy at
                      any time, with reasonable notice at GMGN's sole
                      discretion. Updates will be posted on the Service. Users
                      are encouraged to regularly review this Agreement and the
                      Privacy Policy for any changes. By continuing to use the
                      Platform or Service after such notice, you accept and
                      agree to the revisions. If you disagree with any changes,
                      you must stop using the Platform and Service immediately.{" "}
                    </p>
                    <h5>3. DEFINITIONS AND INTERPRETATION</h5>
                    <p>
                      3.1. Defined Terms. Unless the context otherwise dictates,
                      the following terms in this Agreement will be interpreted
                      as follows:
                    </p>
                    <p>
                      - “Affiliate” refers to any entity or person that,
                      directly or indirectly, controls, is controlled by, or is
                      under common control with a party. This includes, but is
                      not limited to, individuals, firms, corporations,
                      partnerships (general, limited, or limited liability),
                      limited liability companies, and other similar entitie
                    </p>
                    <p>
                      - “Applicable Law” encompasses all relevant federal and
                      state legislation.
                    </p>
                    <p>
                      - “Business Day” denotes any day that is not a Saturday,
                      Sunday, or legal holiday.
                    </p>
                    <p>
                      - “Profile Information” consists of the details provided
                      by a User during the registration process for the Service,
                      including, where applicable, the wallet address, name,
                      address, and the username and password used to access the
                      Service.
                    </p>
                    <p>
                      - “Wallet” means a digital wallet on any chains used by
                      Users to buy, store, and manage cryptocurrencies and
                      tokens, and to conduct transactions on all chains.
                    </p>
                    <p>
                      3.2. Interpretation. References to Sections and Appendices
                      should be interpreted as referring to the Sections and
                      Appendices of this Agreement, unless specified otherwise.
                      Words in the singular form include the plural, and vice
                      versa. Terms such as “hereof,” “herein,” and “hereunder”
                      refer to this Agreement as a whole. The terms “include”
                      and “including” are intended to be illustrative and not
                      restrictive. References to “days” are calendar days unless
                      stated otherwise as Business Days. When “including” is
                      used to list examples, it should be understood as
                      “including, without limitation” or “including but not
                      limited to,” and not as an exhaustive enumeration of
                      covered topics.
                    </p>
                    <h5>4. THE SERVICE</h5>
                    <p>
                      4.1. Purpose of the Services. The Services are designed to
                      enable Users to purchase tokens. They aim to provide
                      aggregated information for the convenience and ease of
                      Users. The Services and the Platform are intended solely
                      for informational and educational purposes and do not
                      constitute financial advice or suggest any trading
                      opportunities. GMGN does not guarantee the accuracy,
                      completeness, or applicability of any information
                      presented on the Platform or through the Services at any
                      given time. Users are solely responsible for any reliance
                      they place on such information. GMGN disclaims all
                      liability for any consequences arising from Users'
                      reliance on the content provided, whether accessed via our
                      Website or through other means. Information collected from
                      Users or provided by them through the Website will be
                      managed in accordance with the Privacy Policy of the
                      Website.
                    </p>
                    <p>
                      4.2. Use of the Services. GMGN grants Users a
                      non-exclusive, limited license to access the Services,
                      including any Website, data, materials, content, or
                      information provided, solely for personal use. This access
                      is restricted to the purposes outlined in these Terms
                      unless expressly authorized otherwise by GMGN for
                      commercial use. Users agree to utilize the Services in
                      compliance with all applicable laws and regulations and to
                      adhere to any rules governing transactions conducted
                      through the Services.
                    </p>
                    <p>
                      4.2.3. User Account Responsibility. USERS ARE SOLELY
                      RESPONSIBLE FOR THE SECURITY OF THEIR ACCOUNTS, INCLUDING
                      THE SAFEGUARDING OF USERNAMES, PASSWORDS, PUBLIC AND/OR
                      PRIVATE KEYS, OR ANY OTHER ACCESS CODES. SHOULD A PASSWORD
                      BE PROVIDED OR CREATED FOR ACCESS TO THE PLATFORM, USERS
                      MUST ENSURE ITS CONFIDENTIALITY. IF A WALLET IS USED TO
                      ACCESS THE PLATFORM, GMGN CANNOT ASSIST IN REGAINING
                      ACCESS IF THE WALLET IS LOST OR CONTROL IS COMPROMISED.
                      Users are accountable for all activities that occur under
                      their account and agree to inform GMGN immediately of any
                      suspected unauthorized access. GMGN is not liable for any
                      losses incurred due to unauthorized activities associated
                      with Users’ accounts, Wallets, or passwords.
                    </p>
                    <p>4.2.4. Additional Considerations</p>
                    <p>
                      4.2.4.1. Transactions and Blockchain Visibility.
                      Transactions conducted on the Platform are recorded on
                      public blockchains. Users acknowledge that their public
                      address will be visible on the blockchain when engaging in
                      transactions through the Platform. GMGN neither owns nor
                      controls any Wallets, blockchain networks, or third-party
                      sites or services used to access or utilize the Platform’s
                      features. GMGN is not responsible for the actions or
                      omissions of these third parties and will not be liable
                      for any damages incurred by Users resulting from
                      transactions or interactions with such third parties.
                    </p>
                    <p>
                      4.2.4.2. Gas Fees. Transactions through the Services are
                      executed via smart contracts on a blockchain network. Gas
                      Fees, which can fluctuate unpredictably, are outside the
                      control of GMGN or the Services. Users understand that
                      transactions cannot be invalidated, revoked, or refunded
                      based on the Gas Fee being unknown, excessive, or
                      otherwise unacceptable.
                    </p>
                    <p>
                      4.2.4.3. Use of Account Information. Verified Users
                      consent to GMGN using their account information for
                      purposes directly related to providing the Service. This
                      access will be limited to the provision of the Service and
                      will not be used for other purposes.
                    </p>
                    <p>
                      4.3. License. Subject to the terms of this Agreement, GMGN
                      grants Users a non-transferable, non-exclusive, revocable,
                      limited license to access the Service solely for personal
                      use, and in accordance with these Terms and Applicable
                      Law. GMGN reserves the right to revoke this license at its
                      sole discretion at any time.
                    </p>
                    <p>4.4. Prohibitions and Restrictions</p>
                    <p>4.4.1. Prohibited Uses. You agree not to:</p>
                    <p>
                      - Use the Services in any way that could damage, disable,
                      overburden, or impair them.
                    </p>
                    <p>
                      - Obtain or attempt to obtain any materials or information
                      through the Services by methods not intentionally provided
                      by GMGN.
                    </p>
                    <p>
                      - Attempt to gain unauthorized access to any account,
                      computer systems, or networks related to GMGN or the
                      Website.
                    </p>
                    <p>
                      - Launch denial-of-service attacks or distributed
                      denial-of-service attacks against the Services.
                    </p>
                    <p>
                      - Impersonate GMGN, its employees, another user, or any
                      other individual or entity.
                    </p>
                    <p>
                      - Modify, create derivative works of, or reverse-engineer
                      any part of the Service.
                    </p>
                    <p>
                      4.4.2. Restrictions. Except as explicitly permitted in
                      this Agreement, you may not copy, reproduce, distribute,
                      republish, or transmit any part of the Service in any form
                      or by any means. All copyright and proprietary notices
                      must be retained on all copies. You also agree not to use
                      the Services for any unlawful purposes.
                    </p>
                    <p>
                      4.5. Modification. GMGN reserves the right to modify,
                      suspend, or discontinue the Services (in whole or in part)
                      at any time, with or without notice. GMGN will not be
                      liable to you or any third party for any changes to,
                      suspension of, or discontinuation of the Services.
                    </p>
                    <p>
                      4.6. No Support or Maintenance. You acknowledge that GMGN
                      has no obligation to provide ongoing support or
                      maintenance for the Services.
                    </p>
                    <p>
                      4.7. Account Suspension. GMGN reserves the right to
                      immediately suspend or terminate your access to the
                      Services, Website, or Platform if GMGN suspects (i)
                      illegal activity involving your account, (ii) fraudulent
                      behavior by you, or (iii) transactions that violate these
                      Terms of Use.
                    </p>
                    <p>
                      4.8. Affiliates. GMGN’s rights and obligations under this
                      Agreement may be exercised by GMGN and its Affiliates, or
                      their subcontractors and agents. GMGN is responsible for
                      the acts and omissions of its Affiliates and any
                      subcontractors or agents concerning this Agreement. Any
                      claims arising from the actions or omissions of GMGN, its
                      Affiliates, or their subcontractors or agents should be
                      directed solely to GMGN and not to its Affiliates or any
                      of their subcontractors or agents.
                    </p>
                    <h5>5. PRIVACY</h5>
                    <p>
                      You agree to GMGN’s Privacy Policy, which is incorporated
                      into this Agreement as if fully detailed herein. The
                      Privacy Policy outlines how GMGN collects, uses, and
                      discloses your information. By using the Services, you
                      consent to the terms of the Privacy Policy and acknowledge
                      its binding effect.
                    </p>
                    <h5>6. THIRD-PARTY LINKS, PRODUCTS, AND APPLICATIONS</h5>
                    <p>
                      6.1. Third-Party Sites. The Services may include links to
                      websites operated by third parties ("Linked Sites"), such
                      as Solscan.io, Telegram, X profiles, or Discord servers.
                      GMGN does not control these Linked Sites and is not
                      responsible for their content, including any links
                      contained within them, or for any changes or updates made
                      to these sites. GMGN is also not liable for any issues
                      related to Linked Sites, such as viruses, malware, or
                      other harmful software that may affect your device. The
                      presence of a link does not imply GMGN’s endorsement or
                      association with the Linked Site or its operators. You are
                      responsible for reviewing and adhering to the privacy
                      policies and terms of use of any Linked Sites you visit.
                      Any interactions or transactions with third parties,
                      including those supporting GMGN or featured in the
                      Services, are your sole responsibility, including the
                      delivery and payment for goods and services. GMGN does not
                      retain information shared with Linked Sites and is not
                      liable for any personally identifiable information
                      provided to such sites
                    </p>
                    <p>
                      6.2. Third-Party Applications. You acknowledge that any
                      use of third-party applications or software available
                      through our Services is at your own risk and discretion.
                      GMGN is not liable for any issues arising from your use of
                      these Third-Party Applications. GMGN disclaims all
                      representations, warranties, or guarantees regarding any
                      Third-Party Applications, whether express, implied, or
                      statutory. This includes, but is not limited to, implied
                      warranties of merchantability or fitness for a particular
                      purpose, as well as any assurances regarding the
                      availability, features, accuracy, completeness, or
                      legality of such applications. You agree to indemnify and
                      hold GMGN harmless from any direct, indirect, punitive,
                      incidental, special, or consequential damages, including
                      but not limited to, damages for loss of use, related to or
                      resulting from the use or performance of Third-Party
                      Applications. GMGN is not responsible for any personally
                      identifiable information shared with Third-Party
                      Applications.
                    </p>
                    <p>
                      6.3. Release. You hereby release GMGN (including our
                      officers, employees, agents, successors, and assigns) from
                      any and all past, present, and future disputes, claims,
                      controversies, demands, rights, obligations, liabilities,
                      actions, and causes of action of any kind and nature. This
                      release applies to any issues directly or indirectly
                      related to the Service, including interactions with or
                      actions or omissions by our partners or any third parties,
                      including Third-Party Links and Applications.
                    </p>
                    <h5>7. INTELLECTUAL PROPERTY</h5>
                    <p>
                      7.1. GMGN Intellectual Property. You acknowledge and agree
                      that GMGN holds all legal rights and interests in all
                      aspects of the Services. This includes the GMGN logo,
                      graphics, design, user interface, website layout, computer
                      code, services, data, and all elements of the Platform
                      (collectively referred to as “GMGN Assets”). The Services,
                      Platform, GMGN Assets, and Content are protected under
                      copyright, trademark, and other proprietary rights. You
                      are not authorized to use the Services or Content in any
                      manner other than as explicitly permitted by GMGN in these
                      Terms. You may not copy, reproduce, modify, publish,
                      transmit, or distribute the Services or Content in any
                      form.
                    </p>
                    <p>
                      Despite any contrary statements in this Agreement, you
                      understand and agree that you do not have any ownership or
                      property interest in your account. All rights to your
                      account are and will remain the exclusive property of
                      GMGN.
                    </p>
                    <p>
                      7.2. Non-GMGN Intellectual Property. Beyond GMGN Assets,
                      any trademarks, product names, logos, and similar
                      intellectual property on the Platform belong to their
                      respective owners. These items may not be copied,
                      imitated, or used, either in whole or in part, without the
                      express permission of the respective trademark holder.
                    </p>
                    <p>7.3. Digital Millennium Copyright Act Compliance</p>
                    <p>
                      Notification. GMGN takes copyright infringement claims
                      seriously and will respond to notices that comply with
                      applicable laws. If you believe that any materials
                      available on or through the Services infringe upon your
                      copyright, you may request their removal by submitting a
                      written notification to GMGN. In accordance with the
                      Digital Millennium Copyright Act (17 U.S.C. § 512)
                      ("DMCA"), your written notice (the "DMCA Notice") should
                      include the following:
                    </p>
                    <p>
                      (a) A physical or electronic signature of a person
                      authorized to act on behalf of the owner of the allegedly
                      infringed exclusive right;
                    </p>
                    <p>
                      (b) Identification of the copyrighted work claimed to be
                      infringed;
                    </p>
                    <p>
                      (c) Identification of the material that is alleged to be
                      infringing or the subject of infringing activity;
                    </p>
                    <p>
                      (d) Information sufficient to allow GMGN to contact the
                      complaining party, including an address, telephone number,
                      and email address;
                    </p>
                    <p>
                      (e) A statement that the complaining party has a good
                      faith belief that the use of the material in the manner
                      complained of is not authorized by the copyright owner,
                      its agent, or the law;
                    </p>
                    <p>
                      (f) A statement that the information provided in the
                      notification is accurate; and
                    </p>
                    <p>
                      (g) A declaration, under penalty of perjury, that the
                      complaining party is authorized to act on behalf of the
                      owner of the allegedly infringed exclusive right.
                    </p>
                    <h5>8. INDEMNIFICATION</h5>
                    <p>
                      You agree to release, indemnify, and hold harmless GMGN,
                      its Affiliates, and their respective officers, directors,
                      employees, and agents from and against any claims,
                      liabilities, damages, losses, and expenses, including,
                      without limitation, reasonable legal and accounting fees,
                      arising out of or in any way related to: (a) your access
                      to, use of, or inability to use the Services; (b) your
                      breach of this Agreement; (c) your violation of any rights
                      of a third party; (d) your violation of any Applicable
                      Law; and (e) any financial losses you may incur, or cause
                      others to incur, as a result of buying and selling tokens,
                      whether or not such transactions were based on information
                      obtained from the Platform or through the Service.
                    </p>
                    <p>
                      8.1. Acknowledgment of Cryptocurrency and Smart Contract
                      Risks
                    </p>
                    <p>
                      You represent and warrant that you understand and accept
                      the risks associated with cryptographic systems, including
                      smart contracts, public blockchain networks (such as the
                      Solana blockchain).
                    </p>

                    <p>8.2. Technical Errors and Blockchain Responsibility</p>

                    <p>
                      GMGN is not responsible for losses resulting from issues
                      with blockchains or features of the Solana network or any
                      other blockchain network incorporated into the Services or
                      Platform, including wallets on any blockchain network.
                      This includes losses due to forks, technical issues, or
                      any other problems that may cause financial loss.
                    </p>

                    <p>
                      Upgrades to the Solana platform or any other blockchain
                      network associated with the Services or Platform,
                      including hard forks or changes in transaction
                      confirmation processes, may have unintended and adverse
                      effects on all blockchains.
                    </p>

                    <p>8.3. Acknowledgment of Platform Risks</p>

                    <p>
                      You acknowledge that the Platform may have inherent flaws
                      and that you are solely responsible for assessing any
                      information provided by the Platform. The warnings and
                      other notices in this Agreement do not constitute an
                      ongoing duty by GMGN to alert you to all potential risks
                      associated with using or accessing the Platform. The
                      Platform may be subject to sophisticated cyber-attacks,
                      unexpected surges in activity, or other operational or
                      technical difficulties that could cause interruptions or
                      delays. You agree to accept the risk of Platform failures
                      resulting from unforeseen or heightened technical issues,
                      including those due to sophisticated attacks, and agree
                      not to hold GMGN liable for any related losses.
                    </p>

                    <p>8.4. No Representations on Digital Asset Value</p>

                    <p>
                      GMGN makes no representations or warranties regarding the
                      value of any digital assets. Blockchain asset prices are
                      highly volatile, and significant changes in the prices of
                      other digital assets can materially and adversely affect
                      the value of tokens. Tokens themselves may also experience
                      significant price volatility due to supply and demand
                      dynamics and their popularity. Additionally, the Platform,
                      cryptocurrencies, NFTs, and other digital assets may be
                      affected by regulatory inquiries or actions. GMGN does not
                      provide any assurances about the value of tokens or other
                      digital assets.
                    </p>

                    <p>8.5. Financial Risk Acknowledgment</p>

                    <p>
                      Trading digital assets carries substantial risk of loss.
                      You should carefully evaluate whether creating, buying, or
                      selling digital assets is appropriate for you, given your
                      circumstances and financial situation. By using the
                      Platform, you represent that you are responsible for
                      independently assessing the risks of any transaction and
                      the underlying digital assets. You confirm that you have
                      adequate knowledge, professional advice, and experience to
                      evaluate the potential gains and losses of any
                      transactions involving digital assets. GMGN will not be
                      financially liable for your use of the Platform or for any
                      losses incurred in connection with buying or selling
                      digital assets.
                    </p>

                    <p>8.6. Violations by Other Users</p>

                    <p>
                      You irrevocably release, acquit, and forever discharge
                      GMGN , its subsidiaries, affiliates, officers, and
                      successors from any and all past or future causes of
                      action, suits, or controversies arising out of violations
                      of these Terms by other Users.
                    </p>

                    <p>8.7. Alpha Callers</p>

                    <p>
                      GMGN does not guarantee the accuracy or effectiveness of
                      any content posted within the Services.
                    </p>

                    <p>
                      Alpha Callers are not employees of GMGN. Any content,
                      advice, predictions, or estimates provided by Alpha
                      Callers should not be considered financial advice. Alpha
                      Callers are not professional investment advisors, and the
                      information they provide should be regarded as
                      entertainment only. You agree to use the information from
                      Alpha Callers at your own risk and acknowledge that it may
                      result in monetary losses. You further agree not to hold
                      any Alpha Callers responsible for financial losses
                      resulting from your decisions to purchase tokens, NFTs, or
                      other assets based on their content.
                    </p>

                    <h5>9. LIMITATION OF LIABILITY AND WARRANTY DISCLAIMER</h5>

                    <p>9.1. Limitation of Liability</p>

                    <p>
                      TO THE MAXIMUM EXTENT PERMITTED BY LAW, GMGN SHALL NOT BE
                      LIABLE TO YOU OR ANY THIRD PARTY FOR ANY FINANCIAL LOSS
                      ARISING FROM OR RELATING TO THESE TERMS OR YOUR USE OF, OR
                      INABILITY TO USE, THE PLATFORM, THE WEBSITE, THE SERVICES,
                      CONTENT, OR INFORMATION ACCESSIBLE THROUGH THE WEBSITE OR
                      ANY HYPERLINKED WEBSITE, OR FOR ANY DISRUPTION OR DELAY IN
                      THE PERFORMANCE OF THE WEBSITE OR THE SERVICES, EVEN IF
                      GMGN HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                      ACCESS TO AND USE OF THE SITES OR SERVICES IS AT YOUR OWN
                      DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE
                      FOR ANY DAMAGE TO YOUR PERSONAL PROPERTY OR LOSS OF DATA
                      RESULTING THEREFROM.
                    </p>

                    <p>9.2. No Warranties</p>

                    <p>
                      ALL INFORMATION AND SERVICES PROVIDED BY GMGN TO YOU VIA
                      THE SERVICES, INCLUDING BUT NOT LIMITED TO ALL CONTENT,
                      ARE PROVIDED &quot;AS IS&quot; AND &quot;WHERE IS&quot;
                      WITHOUT ANY WARRANTIES OF ANY KIND. GMGN AND ANY
                      THIRD-PARTY LICENSORS OF CONTENT ON THE SERVICES EXPRESSLY
                      DISCLAIM ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, OR
                      STATUTORY, INCLUDING BUT NOT LIMITED TO WARRANTIES OF
                      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
                      AND NON-INFRINGEMENT. NOTWITHSTANDING ANY CONTRARY
                      PROVISION HEREIN, GMGN AND ITS THIRD-PARTY LICENSORS MAKE
                      NO REPRESENTATION, WARRANTY, OR COVENANT REGARDING THE
                      ACCURACY, QUALITY, SUITABILITY, COMPLETENESS, SEQUENCE,
                      TIMELINESS, SECURITY, OR AVAILABILITY OF THE WEBSITE OR
                      ANY CONTENT POSTED ON OR OTHERWISE ACCESSIBLE THROUGH THE
                      SERVICES. GMGN MAKES NO WARRANTY THAT THE SERVICES WILL BE
                      FREE OF VIRUSES, WORMS, TROJAN HORSES, OR THAT THEY WILL
                      FUNCTION OR OPERATE IN CONJUNCTION WITH ANY OTHER PRODUCT
                      OR SOFTWARE. YOU EXPRESSLY AGREE THAT USE OF THE SERVICES
                      IS AT YOUR SOLE RISK AND THAT GMGN SHALL NOT BE
                      RESPONSIBLE FOR ANY TERMINATION, INTERRUPTION OF SERVICES,
                      DELAYS, ERRORS, FAILURES OF PERFORMANCE, DEFECTS, LINE
                      FAILURES, OR OMISSIONS ASSOCIATED WITH THE SERVICES OR
                      YOUR USE THEREOF. YOUR SOLE REMEDY FOR DISSATISFACTION
                      WITH THE SERVICES OR CONTENT IS TO CEASE USING THE
                      PLATFORM, WEBSITE, AND/OR SERVICES.
                    </p>

                    <p>
                      9.3. GMGN is Not a Financial Planner or Investment Adviser
                    </p>

                    <p>
                      NEITHER GMGN, THE PLATFORM, NOR THE SERVICES ARE INTENDED
                      TO PROVIDE INVESTMENT OR FINANCIAL ADVICE. GMGN IS NOT A
                      FINANCIAL OR TAX PLANNER AND DOES NOT OFFER LEGAL ADVICE
                      TO ANY USER OF THE SERVICES.
                    </p>

                    <h5>10. TERM AND TERMINATION</h5>

                    <p>
                      This Agreement will remain in full force and effect while
                      you use the Platform or the Service (the
                      &ldquo;Term&rdquo;). GMGN may suspend or terminate your
                      rights to use the Platform or Service at any time and for
                      any reason at its sole discretion, including for any use
                      of the Platform or Service in violation of this Agreement.
                      You may terminate this Agreement at any time by ceasing
                      your use of the Platform and the Service and notifying
                      GMGN. Upon termination of your rights under this
                      Agreement, your right to access and use the Platform and
                      Service will terminate immediately. GMGN will not have any
                      liability whatsoever for any termination of your rights
                      under this Agreement. All provisions of the Agreement
                      which by their nature should survive will continue to
                      apply after termination of the Services, including but not
                      limited to ownership provisions, warranty disclaimers, and
                      limitation of liability.
                    </p>

                    <h5>11. GENERAL TERMS</h5>

                    <p>11.1. Changes to These Terms of Use</p>

                    <p>
                      GMGN may update or change these Terms from time to time to
                      reflect changes in GMGN&apos;s Products or Services,
                      modifications in legislation, or for other reasons as
                      deemed necessary by GMGN. The effective date of any
                      changes will be indicated in the &ldquo;Last
                      Updated&rdquo; entry at the top of these Terms. Your
                      continued use of the Services after such changes are
                      communicated constitutes your acceptance of the updated
                      Terms.
                    </p>

                    <p>11.2. Waiver</p>

                    <p>
                      A waiver by GMGN of any breach of these Terms must be in
                      writing and shall not be construed as a waiver of any
                      subsequent breach of the same provision or any other
                      provision of these Terms.
                    </p>

                    <p>11.3. Governing Law &amp; Jurisdiction</p>
                    <p>
                      These Terms are governed by and construed in accordance
                      with the laws of the province of Australia. You
                      irrevocably consent to the exclusive jurisdiction and
                      venue of the courts located in Australia, for all disputes
                      arising out of or relating to your use of the Services,
                      except as provided in the Arbitration Agreement outlined
                      in Section 13.4.
                    </p>
                    <p>11.4. Dispute Resolution</p>
                    <p>
                      Please review the following arbitration agreement in this
                      Section (&ldquo;Arbitration Agreement&rdquo;) carefully.
                      This agreement mandates that disputes with GMGN be
                      resolved through arbitration, which limits the ways you
                      can seek relief. This Arbitration Agreement is a crucial
                      part of your contract with GMGN and affects your legal
                      rights, including mandatory binding arbitration and a
                      waiver of class action rights.
                    </p>
                    <p>11.4(a). Scope of Arbitration Agreement</p>
                    <p>
                      All disputes and claims (except for those seeking
                      injunctive or other equitable relief as detailed below)
                      related to this Agreement or the use of any GMGN Product
                      or Service that cannot be settled informally must be
                      resolved through binding arbitration on an individual
                      basis under this Arbitration Agreement. Arbitration
                      proceedings will be conducted in English unless otherwise
                      agreed. This Arbitration Agreement applies to you and
                      GMGN, including all subsidiaries, affiliates, agents,
                      employees, predecessors, successors, and assigns of GMGN,
                      and covers all authorized or unauthorized users or
                      beneficiaries of services or goods provided under this
                      Agreement. This Arbitration Agreement also covers all
                      disputes or claims, including those arising before the
                      effective date of this Agreement or any previous versions.
                    </p>
                    <p>
                      11.4(b). Notice Requirement and Informal Dispute
                      Resolution
                    </p>
                    <p>
                      Before initiating arbitration, either party must send a
                      written Notice of Dispute (&ldquo;Notice&rdquo;) to the
                      other party. This Notice should outline the nature of the
                      dispute, the basis for the claim, and the relief sought.
                    </p>
                    <p>
                      After receiving the Notice, both parties will have the
                      opportunity to resolve the dispute informally. If the
                      dispute is not resolved within thirty (30) days from the
                      date of receiving the Notice, either party may proceed
                      with arbitration. During this period, any settlement
                      offers made by either party will remain confidential and
                      will only be disclosed to the arbitrator after the
                      arbitrator has determined the award, if any, that either
                      party is entitled to.
                    </p>
                    <p>11.4(c). Waiver of Jury Trial</p>
                    <p>
                      THE PARTIES HEREBY WAIVE THEIR CONSTITUTIONAL AND
                      STATUTORY RIGHTS TO GO TO COURT AND HAVE A TRIAL IN FRONT
                      OF A JUDGE OR A JURY, INSTEAD ELECTING THAT ALL CLAIMS AND
                      DISPUTES SHALL BE RESOLVED BY ARBITRATION UNDER THIS
                      ARBITRATION AGREEMENT. ARBITRATION PROCEDURES ARE
                      GENERALLY MORE LIMITED, MORE EFFICIENT, AND LESS COSTLY
                      THAN COURT PROCEEDINGS AND ARE SUBJECT TO VERY LIMITED
                      REVIEW BY A COURT. SHOULD ANY LITIGATION ARISE BETWEEN YOU
                      AND GMGN IN ANY STATE OR FEDERAL COURT IN A SUIT TO VACATE
                      OR ENFORCE AN ARBITRATION AWARD OR OTHERWISE, YOU AND GMGN
                      WAIVE ALL RIGHTS TO A JURY TRIAL, INSTEAD ELECTING THAT
                      THE DISPUTE BE RESOLVED BY A JUDGE.
                    </p>
                    <p>11.4(d). Waiver of Class or Consolidated Actions</p>
                    <p>
                      ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS
                      ARBITRATION AGREEMENT MUST BE ARBITRATED OR LITIGATED ON
                      AN INDIVIDUAL BASIS AND NOT ON A CLASS BASIS, AND CLAIMS
                      OF MORE THAN ONE CUSTOMER OR USER CANNOT BE ARBITRATED OR
                      LITIGATED JOINTLY OR CONSOLIDATED WITH THOSE OF ANY OTHER
                      CUSTOMER OR USER.
                    </p>
                    <p>11.4(e). 30-Day Right to Opt Out</p>
                    <p>
                      You may opt out of the provisions of this Arbitration
                      Agreement by sending a written notice of your decision to
                      opt out within thirty (30) days of first becoming subject
                      to this Arbitration Agreement. Your notice must include
                      your name, address, Wallet address, and a clear statement
                      indicating your desire to opt out of this Arbitration
                      Agreement. If you choose to opt out, the remaining
                      provisions of this Agreement will still apply to you.
                      Opting out of this Arbitration Agreement does not affect
                      any other arbitration agreements you may have with GMGN,
                      either currently or in the future.
                    </p>
                    <p>11.4(f). Confidentiality</p>
                    <p>
                      All aspects of the arbitration process, including the
                      arbitrator&apos;s award and any related compliance, will
                      be kept strictly confidential. Both parties agree to
                      uphold this confidentiality unless required by law. This
                      confidentiality clause does not prevent either party from
                      submitting information to a court to enforce this
                      Agreement, enforce an arbitration award, or seek
                      injunctive or equitable relief.
                    </p>
                    <p>11.4(g). Severability</p>
                    <p>
                      If any provision of this Arbitration Agreement is found to
                      be invalid or unenforceable by a court with proper
                      jurisdiction, that specific provision will be deemed null
                      and void, while the remaining provisions of the Agreement
                      will continue in full force and effect.
                    </p>
                    <p>11.4(h). Right to Waive</p>
                    <p>
                      The rights and limitations outlined in this Arbitration
                      Agreement may be waived by the party against whom a claim
                      is asserted. Such a waiver will not affect or waive any
                      other part of this Arbitration Agreement.
                    </p>
                    <p>11.4(i). Survival of Agreement</p>
                    <p>
                      This Arbitration Agreement will remain in effect even
                      after the termination of your relationship with GMGN.
                    </p>
                    <p>11.4(j). Emergency Equitable Relief</p>
                    <p>
                      Despite the provisions above, either party may seek
                      emergency equitable relief from a state or federal court
                      to preserve the status quo while arbitration is pending.
                      Requesting such interim measures will not be considered a
                      waiver of any other rights or obligations under this
                      Arbitration Agreement.
                    </p>
                    <p>11.4(k). Courts</p>
                    <p>
                      In cases where litigation is permitted under this
                      Arbitration Agreement, the parties agree to submit to the
                      personal jurisdiction of the provincial courts located in
                      Australia for such purposes.
                    </p>
                    <p>11.5. Attorneys&rsquo; Fees and Costs</p>
                    <p>
                      In addition to any relief, order, or award issued by an
                      arbitrator or court, the party that is determined to be
                      the substantially losing party in any dispute will be
                      responsible for covering the reasonable attorneys&rsquo;
                      fees and costs incurred by the substantially prevailing
                      party. This includes reimbursing or paying for any
                      arbitrator&rsquo;s fees and expenses incurred by the
                      prevailing party in any arbitration.
                    </p>
                    <p>11.6. Third Party Beneficiaries</p>
                    <p>
                      Except as outlined in Section 11.7, this Agreement and its
                      rights and obligations are intended to benefit only the
                      parties involved and their respective successors and
                      permitted assigns. No other person or entity, whether
                      explicitly or implicitly, will have any rights under this
                      Agreement.
                    </p>
                    <p>11.7. Entire Agreement</p>
                    <p>
                      This Agreement, along with any exhibits or appendices,
                      constitutes the complete and exclusive understanding
                      between the parties regarding the subject matter. It
                      supersedes any prior agreements, whether oral or written,
                      concerning this subject. Each party acknowledges that no
                      other representations, warranties, or agreements have been
                      made except those expressly stated in this Agreement.
                    </p>
                    <p>11.8. Severability</p>
                    <p>
                      Should any provision of this Agreement (or any part
                      thereof) be found invalid or unenforceable by a competent
                      court, such provision will be deemed severed, and the
                      remaining provisions will continue in full force and
                      effect as if the invalid or unenforceable provision had
                      never been included.
                    </p>
                    <p>11.9. Assignment</p>
                    <p>
                      You may not assign or transfer any of your rights under
                      this Agreement without obtaining prior written consent
                      from GMGN. Any attempt to assign or transfer without such
                      consent will be considered void. GMGN retains the right to
                      assign this Agreement or any of its rights hereunder
                      without requiring consent.
                    </p>

                    {/* noi dung */}
                    <div className="line"></div>
                  </div>
                </div>
              </div>

              {/* <Sidebar /> */}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default TermsOfUse;
